/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SemOrganizacaoRouteImport } from './routes/sem-organizacao'
import { Route as RedefinirSenhaRouteImport } from './routes/redefinir-senha'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as EsqueciSenhaRouteImport } from './routes/esqueci-senha'
import { Route as EntrarRouteImport } from './routes/entrar'
import { Route as DesignSystemRouteImport } from './routes/design-system'
import { Route as CadastrarRouteImport } from './routes/cadastrar'
import { Route as AlterarSenhaRouteImport } from './routes/alterar-senha'
import { Route as AceitarConviteRouteImport } from './routes/aceitar-convite'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRelatorioRouteImport } from './routes/_app.relatorio'
import { Route as AppPerfilRouteImport } from './routes/_app.perfil'
import { Route as AppOrganizacaoRouteImport } from './routes/_app.organizacao'
import { Route as AppNpsRouteImport } from './routes/_app.nps'
import { Route as AppLeadsRouteImport } from './routes/_app.leads'
import { Route as AppKanbanRouteImport } from './routes/_app.kanban'
import { Route as AppIntegracoesRouteImport } from './routes/_app.integracoes'
import { Route as AppInboxRouteImport } from './routes/_app.inbox'
import { Route as AppDashboardRouteImport } from './routes/_app.dashboard'
import { Route as AppConvitesRouteImport } from './routes/_app.convites'
import { Route as AppConhecimentoRouteImport } from './routes/_app.conhecimento'
import { Route as AppConfigRouteImport } from './routes/_app.config'
import { Route as AppCampanhasRouteImport } from './routes/_app.campanhas'
import { Route as AppCadenciasRouteImport } from './routes/_app.cadencias'
import { Route as AppAgendamentosRouteImport } from './routes/_app.agendamentos'
import { Route as AppOrganizacaoIndexRouteImport } from './routes/_app.organizacao.index'
import { Route as AppLeadsIndexRouteImport } from './routes/_app.leads.index'
import { Route as AppIntegracoesIndexRouteImport } from './routes/_app.integracoes.index'
import { Route as AppGruposIndexRouteImport } from './routes/_app.grupos.index'
import { Route as AppConhecimentoIndexRouteImport } from './routes/_app.conhecimento.index'
import { Route as AppCanaisIndexRouteImport } from './routes/_app.canais.index'
import { Route as AppCampanhasIndexRouteImport } from './routes/_app.campanhas.index'
import { Route as AppCadenciasIndexRouteImport } from './routes/_app.cadencias.index'
import { Route as AppAgentesIndexRouteImport } from './routes/_app.agentes.index'
import { Route as AppAgendamentosIndexRouteImport } from './routes/_app.agendamentos.index'
import { Route as AppOrganizacaoTemplatesRouteImport } from './routes/_app.organizacao.templates'
import { Route as AppOrganizacaoTagsRouteImport } from './routes/_app.organizacao.tags'
import { Route as AppOrganizacaoSetoresRouteImport } from './routes/_app.organizacao.setores'
import { Route as AppOrganizacaoRespostasRapidasRouteImport } from './routes/_app.organizacao.respostas-rapidas'
import { Route as AppOrganizacaoPrivacidadeRouteImport } from './routes/_app.organizacao.privacidade'
import { Route as AppOrganizacaoNpsRouteImport } from './routes/_app.organizacao.nps'
import { Route as AppOrganizacaoMotivosFinalizacaoRouteImport } from './routes/_app.organizacao.motivos-finalizacao'
import { Route as AppOrganizacaoMidiasRouteImport } from './routes/_app.organizacao.midias'
import { Route as AppOrganizacaoMensagensRouteImport } from './routes/_app.organizacao.mensagens'
import { Route as AppOrganizacaoMembrosRouteImport } from './routes/_app.organizacao.membros'
import { Route as AppOrganizacaoCamposRouteImport } from './routes/_app.organizacao.campos'
import { Route as AppOrganizacaoAssinaturaRouteImport } from './routes/_app.organizacao.assinatura'
import { Route as AppLeadsDuplicadosRouteImport } from './routes/_app.leads.duplicados'
import { Route as AppLeadsLeadIdRouteImport } from './routes/_app.leads.$leadId'
import { Route as AppIntegracoesWebhooksSaidaRouteImport } from './routes/_app.integracoes.webhooks-saida'
import { Route as AppIntegracoesWebhooksRouteImport } from './routes/_app.integracoes.webhooks'
import { Route as AppIntegracoesRdMarketingRouteImport } from './routes/_app.integracoes.rd-marketing'
import { Route as AppIntegracoesMcpRouteImport } from './routes/_app.integracoes.mcp'
import { Route as AppIntegracoesExactSpotterRouteImport } from './routes/_app.integracoes.exact-spotter'
import { Route as AppConhecimentoNovoRouteImport } from './routes/_app.conhecimento.novo'
import { Route as AppConhecimentoKnowledgeBaseIdRouteImport } from './routes/_app.conhecimento.$knowledgeBaseId'
import { Route as AppCampanhasCampaignIdRouteImport } from './routes/_app.campanhas.$campaignId'
import { Route as AppCadenciasCadenceIdRouteImport } from './routes/_app.cadencias.$cadenceId'
import { Route as AppAgentesAgentIdRouteImport } from './routes/_app.agentes.$agentId'
import { Route as AppAgendamentosPerfisRouteImport } from './routes/_app.agendamentos.perfis'
import { Route as AppIntegracoesWebhooksIndexRouteImport } from './routes/_app.integracoes.webhooks.index'
import { Route as AppIntegracoesRdMarketingIndexRouteImport } from './routes/_app.integracoes.rd-marketing.index'
import { Route as AppCadenciasCadenceIdIndexRouteImport } from './routes/_app.cadencias.$cadenceId.index'
import { Route as AppIntegracoesWebhooksNovoRouteImport } from './routes/_app.integracoes.webhooks.novo'
import { Route as AppIntegracoesWebhooksWebhookIdRouteImport } from './routes/_app.integracoes.webhooks.$webhookId'
import { Route as AppIntegracoesRdMarketingLogsRouteImport } from './routes/_app.integracoes.rd-marketing.logs'
import { Route as AppIntegracoesRdMarketingCallbackRouteImport } from './routes/_app.integracoes.rd-marketing.callback'
import { Route as AppIntegracoesGoogleCalendarCallbackRouteImport } from './routes/_app.integracoes.google-calendar.callback'
import { Route as AppCadenciasCadenceIdRelatorioRouteImport } from './routes/_app.cadencias.$cadenceId.relatorio'
import { Route as AppCadenciasCadenceIdLeadsRouteImport } from './routes/_app.cadencias.$cadenceId.leads'
import { Route as AppCadenciasCadenceIdEtapasRouteImport } from './routes/_app.cadencias.$cadenceId.etapas'
import { Route as AppCadenciasCadenceIdAgendaRouteImport } from './routes/_app.cadencias.$cadenceId.agenda'
import { Route as AppAgentesAgentIdTestesRouteImport } from './routes/_app.agentes.$agentId.testes'
import { Route as AppAgentesAgentIdSegurancaRouteImport } from './routes/_app.agentes.$agentId.seguranca'
import { Route as AppAgentesAgentIdQualificacaoRouteImport } from './routes/_app.agentes.$agentId.qualificacao'
import { Route as AppAgentesAgentIdOtimizadorRouteImport } from './routes/_app.agentes.$agentId.otimizador'
import { Route as AppAgentesAgentIdMcpRouteImport } from './routes/_app.agentes.$agentId.mcp'
import { Route as AppAgentesAgentIdConhecimentoRouteImport } from './routes/_app.agentes.$agentId.conhecimento'
import { Route as AppAgentesAgentIdConfiguracoesRouteImport } from './routes/_app.agentes.$agentId.configuracoes'
import { Route as AppAgentesAgentIdAutomacoesRouteImport } from './routes/_app.agentes.$agentId.automacoes'
import { Route as AppAgentesAgentIdAgendamentoRouteImport } from './routes/_app.agentes.$agentId.agendamento'

const SemOrganizacaoRoute = SemOrganizacaoRouteImport.update({
  id: '/sem-organizacao',
  path: '/sem-organizacao',
  getParentRoute: () => rootRouteImport,
} as any)
const RedefinirSenhaRoute = RedefinirSenhaRouteImport.update({
  id: '/redefinir-senha',
  path: '/redefinir-senha',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const EsqueciSenhaRoute = EsqueciSenhaRouteImport.update({
  id: '/esqueci-senha',
  path: '/esqueci-senha',
  getParentRoute: () => rootRouteImport,
} as any)
const EntrarRoute = EntrarRouteImport.update({
  id: '/entrar',
  path: '/entrar',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignSystemRoute = DesignSystemRouteImport.update({
  id: '/design-system',
  path: '/design-system',
  getParentRoute: () => rootRouteImport,
} as any)
const CadastrarRoute = CadastrarRouteImport.update({
  id: '/cadastrar',
  path: '/cadastrar',
  getParentRoute: () => rootRouteImport,
} as any)
const AlterarSenhaRoute = AlterarSenhaRouteImport.update({
  id: '/alterar-senha',
  path: '/alterar-senha',
  getParentRoute: () => rootRouteImport,
} as any)
const AceitarConviteRoute = AceitarConviteRouteImport.update({
  id: '/aceitar-convite',
  path: '/aceitar-convite',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRelatorioRoute = AppRelatorioRouteImport.update({
  id: '/relatorio',
  path: '/relatorio',
  getParentRoute: () => AppRoute,
} as any)
const AppPerfilRoute = AppPerfilRouteImport.update({
  id: '/perfil',
  path: '/perfil',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganizacaoRoute = AppOrganizacaoRouteImport.update({
  id: '/organizacao',
  path: '/organizacao',
  getParentRoute: () => AppRoute,
} as any)
const AppNpsRoute = AppNpsRouteImport.update({
  id: '/nps',
  path: '/nps',
  getParentRoute: () => AppRoute,
} as any)
const AppLeadsRoute = AppLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AppRoute,
} as any)
const AppKanbanRoute = AppKanbanRouteImport.update({
  id: '/kanban',
  path: '/kanban',
  getParentRoute: () => AppRoute,
} as any)
const AppIntegracoesRoute = AppIntegracoesRouteImport.update({
  id: '/integracoes',
  path: '/integracoes',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppConvitesRoute = AppConvitesRouteImport.update({
  id: '/convites',
  path: '/convites',
  getParentRoute: () => AppRoute,
} as any)
const AppConhecimentoRoute = AppConhecimentoRouteImport.update({
  id: '/conhecimento',
  path: '/conhecimento',
  getParentRoute: () => AppRoute,
} as any)
const AppConfigRoute = AppConfigRouteImport.update({
  id: '/config',
  path: '/config',
  getParentRoute: () => AppRoute,
} as any)
const AppCampanhasRoute = AppCampanhasRouteImport.update({
  id: '/campanhas',
  path: '/campanhas',
  getParentRoute: () => AppRoute,
} as any)
const AppCadenciasRoute = AppCadenciasRouteImport.update({
  id: '/cadencias',
  path: '/cadencias',
  getParentRoute: () => AppRoute,
} as any)
const AppAgendamentosRoute = AppAgendamentosRouteImport.update({
  id: '/agendamentos',
  path: '/agendamentos',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganizacaoIndexRoute = AppOrganizacaoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOrganizacaoRoute,
} as any)
const AppLeadsIndexRoute = AppLeadsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLeadsRoute,
} as any)
const AppIntegracoesIndexRoute = AppIntegracoesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppIntegracoesRoute,
} as any)
const AppGruposIndexRoute = AppGruposIndexRouteImport.update({
  id: '/grupos/',
  path: '/grupos/',
  getParentRoute: () => AppRoute,
} as any)
const AppConhecimentoIndexRoute = AppConhecimentoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppConhecimentoRoute,
} as any)
const AppCanaisIndexRoute = AppCanaisIndexRouteImport.update({
  id: '/canais/',
  path: '/canais/',
  getParentRoute: () => AppRoute,
} as any)
const AppCampanhasIndexRoute = AppCampanhasIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCampanhasRoute,
} as any)
const AppCadenciasIndexRoute = AppCadenciasIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCadenciasRoute,
} as any)
const AppAgentesIndexRoute = AppAgentesIndexRouteImport.update({
  id: '/agentes/',
  path: '/agentes/',
  getParentRoute: () => AppRoute,
} as any)
const AppAgendamentosIndexRoute = AppAgendamentosIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAgendamentosRoute,
} as any)
const AppOrganizacaoTemplatesRoute = AppOrganizacaoTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppOrganizacaoRoute,
} as any)
const AppOrganizacaoTagsRoute = AppOrganizacaoTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AppOrganizacaoRoute,
} as any)
const AppOrganizacaoSetoresRoute = AppOrganizacaoSetoresRouteImport.update({
  id: '/setores',
  path: '/setores',
  getParentRoute: () => AppOrganizacaoRoute,
} as any)
const AppOrganizacaoRespostasRapidasRoute =
  AppOrganizacaoRespostasRapidasRouteImport.update({
    id: '/respostas-rapidas',
    path: '/respostas-rapidas',
    getParentRoute: () => AppOrganizacaoRoute,
  } as any)
const AppOrganizacaoPrivacidadeRoute =
  AppOrganizacaoPrivacidadeRouteImport.update({
    id: '/privacidade',
    path: '/privacidade',
    getParentRoute: () => AppOrganizacaoRoute,
  } as any)
const AppOrganizacaoNpsRoute = AppOrganizacaoNpsRouteImport.update({
  id: '/nps',
  path: '/nps',
  getParentRoute: () => AppOrganizacaoRoute,
} as any)
const AppOrganizacaoMotivosFinalizacaoRoute =
  AppOrganizacaoMotivosFinalizacaoRouteImport.update({
    id: '/motivos-finalizacao',
    path: '/motivos-finalizacao',
    getParentRoute: () => AppOrganizacaoRoute,
  } as any)
const AppOrganizacaoMidiasRoute = AppOrganizacaoMidiasRouteImport.update({
  id: '/midias',
  path: '/midias',
  getParentRoute: () => AppOrganizacaoRoute,
} as any)
const AppOrganizacaoMensagensRoute = AppOrganizacaoMensagensRouteImport.update({
  id: '/mensagens',
  path: '/mensagens',
  getParentRoute: () => AppOrganizacaoRoute,
} as any)
const AppOrganizacaoMembrosRoute = AppOrganizacaoMembrosRouteImport.update({
  id: '/membros',
  path: '/membros',
  getParentRoute: () => AppOrganizacaoRoute,
} as any)
const AppOrganizacaoCamposRoute = AppOrganizacaoCamposRouteImport.update({
  id: '/campos',
  path: '/campos',
  getParentRoute: () => AppOrganizacaoRoute,
} as any)
const AppOrganizacaoAssinaturaRoute =
  AppOrganizacaoAssinaturaRouteImport.update({
    id: '/assinatura',
    path: '/assinatura',
    getParentRoute: () => AppOrganizacaoRoute,
  } as any)
const AppLeadsDuplicadosRoute = AppLeadsDuplicadosRouteImport.update({
  id: '/duplicados',
  path: '/duplicados',
  getParentRoute: () => AppLeadsRoute,
} as any)
const AppLeadsLeadIdRoute = AppLeadsLeadIdRouteImport.update({
  id: '/$leadId',
  path: '/$leadId',
  getParentRoute: () => AppLeadsRoute,
} as any)
const AppIntegracoesWebhooksSaidaRoute =
  AppIntegracoesWebhooksSaidaRouteImport.update({
    id: '/webhooks-saida',
    path: '/webhooks-saida',
    getParentRoute: () => AppIntegracoesRoute,
  } as any)
const AppIntegracoesWebhooksRoute = AppIntegracoesWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => AppIntegracoesRoute,
} as any)
const AppIntegracoesRdMarketingRoute =
  AppIntegracoesRdMarketingRouteImport.update({
    id: '/rd-marketing',
    path: '/rd-marketing',
    getParentRoute: () => AppIntegracoesRoute,
  } as any)
const AppIntegracoesMcpRoute = AppIntegracoesMcpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => AppIntegracoesRoute,
} as any)
const AppIntegracoesExactSpotterRoute =
  AppIntegracoesExactSpotterRouteImport.update({
    id: '/exact-spotter',
    path: '/exact-spotter',
    getParentRoute: () => AppIntegracoesRoute,
  } as any)
const AppConhecimentoNovoRoute = AppConhecimentoNovoRouteImport.update({
  id: '/novo',
  path: '/novo',
  getParentRoute: () => AppConhecimentoRoute,
} as any)
const AppConhecimentoKnowledgeBaseIdRoute =
  AppConhecimentoKnowledgeBaseIdRouteImport.update({
    id: '/$knowledgeBaseId',
    path: '/$knowledgeBaseId',
    getParentRoute: () => AppConhecimentoRoute,
  } as any)
const AppCampanhasCampaignIdRoute = AppCampanhasCampaignIdRouteImport.update({
  id: '/$campaignId',
  path: '/$campaignId',
  getParentRoute: () => AppCampanhasRoute,
} as any)
const AppCadenciasCadenceIdRoute = AppCadenciasCadenceIdRouteImport.update({
  id: '/$cadenceId',
  path: '/$cadenceId',
  getParentRoute: () => AppCadenciasRoute,
} as any)
const AppAgentesAgentIdRoute = AppAgentesAgentIdRouteImport.update({
  id: '/agentes/$agentId',
  path: '/agentes/$agentId',
  getParentRoute: () => AppRoute,
} as any)
const AppAgendamentosPerfisRoute = AppAgendamentosPerfisRouteImport.update({
  id: '/perfis',
  path: '/perfis',
  getParentRoute: () => AppAgendamentosRoute,
} as any)
const AppIntegracoesWebhooksIndexRoute =
  AppIntegracoesWebhooksIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppIntegracoesWebhooksRoute,
  } as any)
const AppIntegracoesRdMarketingIndexRoute =
  AppIntegracoesRdMarketingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppIntegracoesRdMarketingRoute,
  } as any)
const AppCadenciasCadenceIdIndexRoute =
  AppCadenciasCadenceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCadenciasCadenceIdRoute,
  } as any)
const AppIntegracoesWebhooksNovoRoute =
  AppIntegracoesWebhooksNovoRouteImport.update({
    id: '/novo',
    path: '/novo',
    getParentRoute: () => AppIntegracoesWebhooksRoute,
  } as any)
const AppIntegracoesWebhooksWebhookIdRoute =
  AppIntegracoesWebhooksWebhookIdRouteImport.update({
    id: '/$webhookId',
    path: '/$webhookId',
    getParentRoute: () => AppIntegracoesWebhooksRoute,
  } as any)
const AppIntegracoesRdMarketingLogsRoute =
  AppIntegracoesRdMarketingLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => AppIntegracoesRdMarketingRoute,
  } as any)
const AppIntegracoesRdMarketingCallbackRoute =
  AppIntegracoesRdMarketingCallbackRouteImport.update({
    id: '/callback',
    path: '/callback',
    getParentRoute: () => AppIntegracoesRdMarketingRoute,
  } as any)
const AppIntegracoesGoogleCalendarCallbackRoute =
  AppIntegracoesGoogleCalendarCallbackRouteImport.update({
    id: '/google-calendar/callback',
    path: '/google-calendar/callback',
    getParentRoute: () => AppIntegracoesRoute,
  } as any)
const AppCadenciasCadenceIdRelatorioRoute =
  AppCadenciasCadenceIdRelatorioRouteImport.update({
    id: '/relatorio',
    path: '/relatorio',
    getParentRoute: () => AppCadenciasCadenceIdRoute,
  } as any)
const AppCadenciasCadenceIdLeadsRoute =
  AppCadenciasCadenceIdLeadsRouteImport.update({
    id: '/leads',
    path: '/leads',
    getParentRoute: () => AppCadenciasCadenceIdRoute,
  } as any)
const AppCadenciasCadenceIdEtapasRoute =
  AppCadenciasCadenceIdEtapasRouteImport.update({
    id: '/etapas',
    path: '/etapas',
    getParentRoute: () => AppCadenciasCadenceIdRoute,
  } as any)
const AppCadenciasCadenceIdAgendaRoute =
  AppCadenciasCadenceIdAgendaRouteImport.update({
    id: '/agenda',
    path: '/agenda',
    getParentRoute: () => AppCadenciasCadenceIdRoute,
  } as any)
const AppAgentesAgentIdTestesRoute = AppAgentesAgentIdTestesRouteImport.update({
  id: '/testes',
  path: '/testes',
  getParentRoute: () => AppAgentesAgentIdRoute,
} as any)
const AppAgentesAgentIdSegurancaRoute =
  AppAgentesAgentIdSegurancaRouteImport.update({
    id: '/seguranca',
    path: '/seguranca',
    getParentRoute: () => AppAgentesAgentIdRoute,
  } as any)
const AppAgentesAgentIdQualificacaoRoute =
  AppAgentesAgentIdQualificacaoRouteImport.update({
    id: '/qualificacao',
    path: '/qualificacao',
    getParentRoute: () => AppAgentesAgentIdRoute,
  } as any)
const AppAgentesAgentIdOtimizadorRoute =
  AppAgentesAgentIdOtimizadorRouteImport.update({
    id: '/otimizador',
    path: '/otimizador',
    getParentRoute: () => AppAgentesAgentIdRoute,
  } as any)
const AppAgentesAgentIdMcpRoute = AppAgentesAgentIdMcpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => AppAgentesAgentIdRoute,
} as any)
const AppAgentesAgentIdConhecimentoRoute =
  AppAgentesAgentIdConhecimentoRouteImport.update({
    id: '/conhecimento',
    path: '/conhecimento',
    getParentRoute: () => AppAgentesAgentIdRoute,
  } as any)
const AppAgentesAgentIdConfiguracoesRoute =
  AppAgentesAgentIdConfiguracoesRouteImport.update({
    id: '/configuracoes',
    path: '/configuracoes',
    getParentRoute: () => AppAgentesAgentIdRoute,
  } as any)
const AppAgentesAgentIdAutomacoesRoute =
  AppAgentesAgentIdAutomacoesRouteImport.update({
    id: '/automacoes',
    path: '/automacoes',
    getParentRoute: () => AppAgentesAgentIdRoute,
  } as any)
const AppAgentesAgentIdAgendamentoRoute =
  AppAgentesAgentIdAgendamentoRouteImport.update({
    id: '/agendamento',
    path: '/agendamento',
    getParentRoute: () => AppAgentesAgentIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/aceitar-convite': typeof AceitarConviteRoute
  '/alterar-senha': typeof AlterarSenhaRoute
  '/cadastrar': typeof CadastrarRoute
  '/design-system': typeof DesignSystemRoute
  '/entrar': typeof EntrarRoute
  '/esqueci-senha': typeof EsqueciSenhaRoute
  '/onboarding': typeof OnboardingRoute
  '/redefinir-senha': typeof RedefinirSenhaRoute
  '/sem-organizacao': typeof SemOrganizacaoRoute
  '/agendamentos': typeof AppAgendamentosRouteWithChildren
  '/cadencias': typeof AppCadenciasRouteWithChildren
  '/campanhas': typeof AppCampanhasRouteWithChildren
  '/config': typeof AppConfigRoute
  '/conhecimento': typeof AppConhecimentoRouteWithChildren
  '/convites': typeof AppConvitesRoute
  '/dashboard': typeof AppDashboardRoute
  '/inbox': typeof AppInboxRoute
  '/integracoes': typeof AppIntegracoesRouteWithChildren
  '/kanban': typeof AppKanbanRoute
  '/leads': typeof AppLeadsRouteWithChildren
  '/nps': typeof AppNpsRoute
  '/organizacao': typeof AppOrganizacaoRouteWithChildren
  '/perfil': typeof AppPerfilRoute
  '/relatorio': typeof AppRelatorioRoute
  '/agendamentos/perfis': typeof AppAgendamentosPerfisRoute
  '/agentes/$agentId': typeof AppAgentesAgentIdRouteWithChildren
  '/cadencias/$cadenceId': typeof AppCadenciasCadenceIdRouteWithChildren
  '/campanhas/$campaignId': typeof AppCampanhasCampaignIdRoute
  '/conhecimento/$knowledgeBaseId': typeof AppConhecimentoKnowledgeBaseIdRoute
  '/conhecimento/novo': typeof AppConhecimentoNovoRoute
  '/integracoes/exact-spotter': typeof AppIntegracoesExactSpotterRoute
  '/integracoes/mcp': typeof AppIntegracoesMcpRoute
  '/integracoes/rd-marketing': typeof AppIntegracoesRdMarketingRouteWithChildren
  '/integracoes/webhooks': typeof AppIntegracoesWebhooksRouteWithChildren
  '/integracoes/webhooks-saida': typeof AppIntegracoesWebhooksSaidaRoute
  '/leads/$leadId': typeof AppLeadsLeadIdRoute
  '/leads/duplicados': typeof AppLeadsDuplicadosRoute
  '/organizacao/assinatura': typeof AppOrganizacaoAssinaturaRoute
  '/organizacao/campos': typeof AppOrganizacaoCamposRoute
  '/organizacao/membros': typeof AppOrganizacaoMembrosRoute
  '/organizacao/mensagens': typeof AppOrganizacaoMensagensRoute
  '/organizacao/midias': typeof AppOrganizacaoMidiasRoute
  '/organizacao/motivos-finalizacao': typeof AppOrganizacaoMotivosFinalizacaoRoute
  '/organizacao/nps': typeof AppOrganizacaoNpsRoute
  '/organizacao/privacidade': typeof AppOrganizacaoPrivacidadeRoute
  '/organizacao/respostas-rapidas': typeof AppOrganizacaoRespostasRapidasRoute
  '/organizacao/setores': typeof AppOrganizacaoSetoresRoute
  '/organizacao/tags': typeof AppOrganizacaoTagsRoute
  '/organizacao/templates': typeof AppOrganizacaoTemplatesRoute
  '/agendamentos/': typeof AppAgendamentosIndexRoute
  '/agentes/': typeof AppAgentesIndexRoute
  '/cadencias/': typeof AppCadenciasIndexRoute
  '/campanhas/': typeof AppCampanhasIndexRoute
  '/canais/': typeof AppCanaisIndexRoute
  '/conhecimento/': typeof AppConhecimentoIndexRoute
  '/grupos/': typeof AppGruposIndexRoute
  '/integracoes/': typeof AppIntegracoesIndexRoute
  '/leads/': typeof AppLeadsIndexRoute
  '/organizacao/': typeof AppOrganizacaoIndexRoute
  '/agentes/$agentId/agendamento': typeof AppAgentesAgentIdAgendamentoRoute
  '/agentes/$agentId/automacoes': typeof AppAgentesAgentIdAutomacoesRoute
  '/agentes/$agentId/configuracoes': typeof AppAgentesAgentIdConfiguracoesRoute
  '/agentes/$agentId/conhecimento': typeof AppAgentesAgentIdConhecimentoRoute
  '/agentes/$agentId/mcp': typeof AppAgentesAgentIdMcpRoute
  '/agentes/$agentId/otimizador': typeof AppAgentesAgentIdOtimizadorRoute
  '/agentes/$agentId/qualificacao': typeof AppAgentesAgentIdQualificacaoRoute
  '/agentes/$agentId/seguranca': typeof AppAgentesAgentIdSegurancaRoute
  '/agentes/$agentId/testes': typeof AppAgentesAgentIdTestesRoute
  '/cadencias/$cadenceId/agenda': typeof AppCadenciasCadenceIdAgendaRoute
  '/cadencias/$cadenceId/etapas': typeof AppCadenciasCadenceIdEtapasRoute
  '/cadencias/$cadenceId/leads': typeof AppCadenciasCadenceIdLeadsRoute
  '/cadencias/$cadenceId/relatorio': typeof AppCadenciasCadenceIdRelatorioRoute
  '/integracoes/google-calendar/callback': typeof AppIntegracoesGoogleCalendarCallbackRoute
  '/integracoes/rd-marketing/callback': typeof AppIntegracoesRdMarketingCallbackRoute
  '/integracoes/rd-marketing/logs': typeof AppIntegracoesRdMarketingLogsRoute
  '/integracoes/webhooks/$webhookId': typeof AppIntegracoesWebhooksWebhookIdRoute
  '/integracoes/webhooks/novo': typeof AppIntegracoesWebhooksNovoRoute
  '/cadencias/$cadenceId/': typeof AppCadenciasCadenceIdIndexRoute
  '/integracoes/rd-marketing/': typeof AppIntegracoesRdMarketingIndexRoute
  '/integracoes/webhooks/': typeof AppIntegracoesWebhooksIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/aceitar-convite': typeof AceitarConviteRoute
  '/alterar-senha': typeof AlterarSenhaRoute
  '/cadastrar': typeof CadastrarRoute
  '/design-system': typeof DesignSystemRoute
  '/entrar': typeof EntrarRoute
  '/esqueci-senha': typeof EsqueciSenhaRoute
  '/onboarding': typeof OnboardingRoute
  '/redefinir-senha': typeof RedefinirSenhaRoute
  '/sem-organizacao': typeof SemOrganizacaoRoute
  '/config': typeof AppConfigRoute
  '/convites': typeof AppConvitesRoute
  '/dashboard': typeof AppDashboardRoute
  '/inbox': typeof AppInboxRoute
  '/kanban': typeof AppKanbanRoute
  '/nps': typeof AppNpsRoute
  '/perfil': typeof AppPerfilRoute
  '/relatorio': typeof AppRelatorioRoute
  '/agendamentos/perfis': typeof AppAgendamentosPerfisRoute
  '/agentes/$agentId': typeof AppAgentesAgentIdRouteWithChildren
  '/campanhas/$campaignId': typeof AppCampanhasCampaignIdRoute
  '/conhecimento/$knowledgeBaseId': typeof AppConhecimentoKnowledgeBaseIdRoute
  '/conhecimento/novo': typeof AppConhecimentoNovoRoute
  '/integracoes/exact-spotter': typeof AppIntegracoesExactSpotterRoute
  '/integracoes/mcp': typeof AppIntegracoesMcpRoute
  '/integracoes/webhooks-saida': typeof AppIntegracoesWebhooksSaidaRoute
  '/leads/$leadId': typeof AppLeadsLeadIdRoute
  '/leads/duplicados': typeof AppLeadsDuplicadosRoute
  '/organizacao/assinatura': typeof AppOrganizacaoAssinaturaRoute
  '/organizacao/campos': typeof AppOrganizacaoCamposRoute
  '/organizacao/membros': typeof AppOrganizacaoMembrosRoute
  '/organizacao/mensagens': typeof AppOrganizacaoMensagensRoute
  '/organizacao/midias': typeof AppOrganizacaoMidiasRoute
  '/organizacao/motivos-finalizacao': typeof AppOrganizacaoMotivosFinalizacaoRoute
  '/organizacao/nps': typeof AppOrganizacaoNpsRoute
  '/organizacao/privacidade': typeof AppOrganizacaoPrivacidadeRoute
  '/organizacao/respostas-rapidas': typeof AppOrganizacaoRespostasRapidasRoute
  '/organizacao/setores': typeof AppOrganizacaoSetoresRoute
  '/organizacao/tags': typeof AppOrganizacaoTagsRoute
  '/organizacao/templates': typeof AppOrganizacaoTemplatesRoute
  '/agendamentos': typeof AppAgendamentosIndexRoute
  '/agentes': typeof AppAgentesIndexRoute
  '/cadencias': typeof AppCadenciasIndexRoute
  '/campanhas': typeof AppCampanhasIndexRoute
  '/canais': typeof AppCanaisIndexRoute
  '/conhecimento': typeof AppConhecimentoIndexRoute
  '/grupos': typeof AppGruposIndexRoute
  '/integracoes': typeof AppIntegracoesIndexRoute
  '/leads': typeof AppLeadsIndexRoute
  '/organizacao': typeof AppOrganizacaoIndexRoute
  '/agentes/$agentId/agendamento': typeof AppAgentesAgentIdAgendamentoRoute
  '/agentes/$agentId/automacoes': typeof AppAgentesAgentIdAutomacoesRoute
  '/agentes/$agentId/configuracoes': typeof AppAgentesAgentIdConfiguracoesRoute
  '/agentes/$agentId/conhecimento': typeof AppAgentesAgentIdConhecimentoRoute
  '/agentes/$agentId/mcp': typeof AppAgentesAgentIdMcpRoute
  '/agentes/$agentId/otimizador': typeof AppAgentesAgentIdOtimizadorRoute
  '/agentes/$agentId/qualificacao': typeof AppAgentesAgentIdQualificacaoRoute
  '/agentes/$agentId/seguranca': typeof AppAgentesAgentIdSegurancaRoute
  '/agentes/$agentId/testes': typeof AppAgentesAgentIdTestesRoute
  '/cadencias/$cadenceId/agenda': typeof AppCadenciasCadenceIdAgendaRoute
  '/cadencias/$cadenceId/etapas': typeof AppCadenciasCadenceIdEtapasRoute
  '/cadencias/$cadenceId/leads': typeof AppCadenciasCadenceIdLeadsRoute
  '/cadencias/$cadenceId/relatorio': typeof AppCadenciasCadenceIdRelatorioRoute
  '/integracoes/google-calendar/callback': typeof AppIntegracoesGoogleCalendarCallbackRoute
  '/integracoes/rd-marketing/callback': typeof AppIntegracoesRdMarketingCallbackRoute
  '/integracoes/rd-marketing/logs': typeof AppIntegracoesRdMarketingLogsRoute
  '/integracoes/webhooks/$webhookId': typeof AppIntegracoesWebhooksWebhookIdRoute
  '/integracoes/webhooks/novo': typeof AppIntegracoesWebhooksNovoRoute
  '/cadencias/$cadenceId': typeof AppCadenciasCadenceIdIndexRoute
  '/integracoes/rd-marketing': typeof AppIntegracoesRdMarketingIndexRoute
  '/integracoes/webhooks': typeof AppIntegracoesWebhooksIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/aceitar-convite': typeof AceitarConviteRoute
  '/alterar-senha': typeof AlterarSenhaRoute
  '/cadastrar': typeof CadastrarRoute
  '/design-system': typeof DesignSystemRoute
  '/entrar': typeof EntrarRoute
  '/esqueci-senha': typeof EsqueciSenhaRoute
  '/onboarding': typeof OnboardingRoute
  '/redefinir-senha': typeof RedefinirSenhaRoute
  '/sem-organizacao': typeof SemOrganizacaoRoute
  '/_app/agendamentos': typeof AppAgendamentosRouteWithChildren
  '/_app/cadencias': typeof AppCadenciasRouteWithChildren
  '/_app/campanhas': typeof AppCampanhasRouteWithChildren
  '/_app/config': typeof AppConfigRoute
  '/_app/conhecimento': typeof AppConhecimentoRouteWithChildren
  '/_app/convites': typeof AppConvitesRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/inbox': typeof AppInboxRoute
  '/_app/integracoes': typeof AppIntegracoesRouteWithChildren
  '/_app/kanban': typeof AppKanbanRoute
  '/_app/leads': typeof AppLeadsRouteWithChildren
  '/_app/nps': typeof AppNpsRoute
  '/_app/organizacao': typeof AppOrganizacaoRouteWithChildren
  '/_app/perfil': typeof AppPerfilRoute
  '/_app/relatorio': typeof AppRelatorioRoute
  '/_app/agendamentos/perfis': typeof AppAgendamentosPerfisRoute
  '/_app/agentes/$agentId': typeof AppAgentesAgentIdRouteWithChildren
  '/_app/cadencias/$cadenceId': typeof AppCadenciasCadenceIdRouteWithChildren
  '/_app/campanhas/$campaignId': typeof AppCampanhasCampaignIdRoute
  '/_app/conhecimento/$knowledgeBaseId': typeof AppConhecimentoKnowledgeBaseIdRoute
  '/_app/conhecimento/novo': typeof AppConhecimentoNovoRoute
  '/_app/integracoes/exact-spotter': typeof AppIntegracoesExactSpotterRoute
  '/_app/integracoes/mcp': typeof AppIntegracoesMcpRoute
  '/_app/integracoes/rd-marketing': typeof AppIntegracoesRdMarketingRouteWithChildren
  '/_app/integracoes/webhooks': typeof AppIntegracoesWebhooksRouteWithChildren
  '/_app/integracoes/webhooks-saida': typeof AppIntegracoesWebhooksSaidaRoute
  '/_app/leads/$leadId': typeof AppLeadsLeadIdRoute
  '/_app/leads/duplicados': typeof AppLeadsDuplicadosRoute
  '/_app/organizacao/assinatura': typeof AppOrganizacaoAssinaturaRoute
  '/_app/organizacao/campos': typeof AppOrganizacaoCamposRoute
  '/_app/organizacao/membros': typeof AppOrganizacaoMembrosRoute
  '/_app/organizacao/mensagens': typeof AppOrganizacaoMensagensRoute
  '/_app/organizacao/midias': typeof AppOrganizacaoMidiasRoute
  '/_app/organizacao/motivos-finalizacao': typeof AppOrganizacaoMotivosFinalizacaoRoute
  '/_app/organizacao/nps': typeof AppOrganizacaoNpsRoute
  '/_app/organizacao/privacidade': typeof AppOrganizacaoPrivacidadeRoute
  '/_app/organizacao/respostas-rapidas': typeof AppOrganizacaoRespostasRapidasRoute
  '/_app/organizacao/setores': typeof AppOrganizacaoSetoresRoute
  '/_app/organizacao/tags': typeof AppOrganizacaoTagsRoute
  '/_app/organizacao/templates': typeof AppOrganizacaoTemplatesRoute
  '/_app/agendamentos/': typeof AppAgendamentosIndexRoute
  '/_app/agentes/': typeof AppAgentesIndexRoute
  '/_app/cadencias/': typeof AppCadenciasIndexRoute
  '/_app/campanhas/': typeof AppCampanhasIndexRoute
  '/_app/canais/': typeof AppCanaisIndexRoute
  '/_app/conhecimento/': typeof AppConhecimentoIndexRoute
  '/_app/grupos/': typeof AppGruposIndexRoute
  '/_app/integracoes/': typeof AppIntegracoesIndexRoute
  '/_app/leads/': typeof AppLeadsIndexRoute
  '/_app/organizacao/': typeof AppOrganizacaoIndexRoute
  '/_app/agentes/$agentId/agendamento': typeof AppAgentesAgentIdAgendamentoRoute
  '/_app/agentes/$agentId/automacoes': typeof AppAgentesAgentIdAutomacoesRoute
  '/_app/agentes/$agentId/configuracoes': typeof AppAgentesAgentIdConfiguracoesRoute
  '/_app/agentes/$agentId/conhecimento': typeof AppAgentesAgentIdConhecimentoRoute
  '/_app/agentes/$agentId/mcp': typeof AppAgentesAgentIdMcpRoute
  '/_app/agentes/$agentId/otimizador': typeof AppAgentesAgentIdOtimizadorRoute
  '/_app/agentes/$agentId/qualificacao': typeof AppAgentesAgentIdQualificacaoRoute
  '/_app/agentes/$agentId/seguranca': typeof AppAgentesAgentIdSegurancaRoute
  '/_app/agentes/$agentId/testes': typeof AppAgentesAgentIdTestesRoute
  '/_app/cadencias/$cadenceId/agenda': typeof AppCadenciasCadenceIdAgendaRoute
  '/_app/cadencias/$cadenceId/etapas': typeof AppCadenciasCadenceIdEtapasRoute
  '/_app/cadencias/$cadenceId/leads': typeof AppCadenciasCadenceIdLeadsRoute
  '/_app/cadencias/$cadenceId/relatorio': typeof AppCadenciasCadenceIdRelatorioRoute
  '/_app/integracoes/google-calendar/callback': typeof AppIntegracoesGoogleCalendarCallbackRoute
  '/_app/integracoes/rd-marketing/callback': typeof AppIntegracoesRdMarketingCallbackRoute
  '/_app/integracoes/rd-marketing/logs': typeof AppIntegracoesRdMarketingLogsRoute
  '/_app/integracoes/webhooks/$webhookId': typeof AppIntegracoesWebhooksWebhookIdRoute
  '/_app/integracoes/webhooks/novo': typeof AppIntegracoesWebhooksNovoRoute
  '/_app/cadencias/$cadenceId/': typeof AppCadenciasCadenceIdIndexRoute
  '/_app/integracoes/rd-marketing/': typeof AppIntegracoesRdMarketingIndexRoute
  '/_app/integracoes/webhooks/': typeof AppIntegracoesWebhooksIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/aceitar-convite'
    | '/alterar-senha'
    | '/cadastrar'
    | '/design-system'
    | '/entrar'
    | '/esqueci-senha'
    | '/onboarding'
    | '/redefinir-senha'
    | '/sem-organizacao'
    | '/agendamentos'
    | '/cadencias'
    | '/campanhas'
    | '/config'
    | '/conhecimento'
    | '/convites'
    | '/dashboard'
    | '/inbox'
    | '/integracoes'
    | '/kanban'
    | '/leads'
    | '/nps'
    | '/organizacao'
    | '/perfil'
    | '/relatorio'
    | '/agendamentos/perfis'
    | '/agentes/$agentId'
    | '/cadencias/$cadenceId'
    | '/campanhas/$campaignId'
    | '/conhecimento/$knowledgeBaseId'
    | '/conhecimento/novo'
    | '/integracoes/exact-spotter'
    | '/integracoes/mcp'
    | '/integracoes/rd-marketing'
    | '/integracoes/webhooks'
    | '/integracoes/webhooks-saida'
    | '/leads/$leadId'
    | '/leads/duplicados'
    | '/organizacao/assinatura'
    | '/organizacao/campos'
    | '/organizacao/membros'
    | '/organizacao/mensagens'
    | '/organizacao/midias'
    | '/organizacao/motivos-finalizacao'
    | '/organizacao/nps'
    | '/organizacao/privacidade'
    | '/organizacao/respostas-rapidas'
    | '/organizacao/setores'
    | '/organizacao/tags'
    | '/organizacao/templates'
    | '/agendamentos/'
    | '/agentes/'
    | '/cadencias/'
    | '/campanhas/'
    | '/canais/'
    | '/conhecimento/'
    | '/grupos/'
    | '/integracoes/'
    | '/leads/'
    | '/organizacao/'
    | '/agentes/$agentId/agendamento'
    | '/agentes/$agentId/automacoes'
    | '/agentes/$agentId/configuracoes'
    | '/agentes/$agentId/conhecimento'
    | '/agentes/$agentId/mcp'
    | '/agentes/$agentId/otimizador'
    | '/agentes/$agentId/qualificacao'
    | '/agentes/$agentId/seguranca'
    | '/agentes/$agentId/testes'
    | '/cadencias/$cadenceId/agenda'
    | '/cadencias/$cadenceId/etapas'
    | '/cadencias/$cadenceId/leads'
    | '/cadencias/$cadenceId/relatorio'
    | '/integracoes/google-calendar/callback'
    | '/integracoes/rd-marketing/callback'
    | '/integracoes/rd-marketing/logs'
    | '/integracoes/webhooks/$webhookId'
    | '/integracoes/webhooks/novo'
    | '/cadencias/$cadenceId/'
    | '/integracoes/rd-marketing/'
    | '/integracoes/webhooks/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/aceitar-convite'
    | '/alterar-senha'
    | '/cadastrar'
    | '/design-system'
    | '/entrar'
    | '/esqueci-senha'
    | '/onboarding'
    | '/redefinir-senha'
    | '/sem-organizacao'
    | '/config'
    | '/convites'
    | '/dashboard'
    | '/inbox'
    | '/kanban'
    | '/nps'
    | '/perfil'
    | '/relatorio'
    | '/agendamentos/perfis'
    | '/agentes/$agentId'
    | '/campanhas/$campaignId'
    | '/conhecimento/$knowledgeBaseId'
    | '/conhecimento/novo'
    | '/integracoes/exact-spotter'
    | '/integracoes/mcp'
    | '/integracoes/webhooks-saida'
    | '/leads/$leadId'
    | '/leads/duplicados'
    | '/organizacao/assinatura'
    | '/organizacao/campos'
    | '/organizacao/membros'
    | '/organizacao/mensagens'
    | '/organizacao/midias'
    | '/organizacao/motivos-finalizacao'
    | '/organizacao/nps'
    | '/organizacao/privacidade'
    | '/organizacao/respostas-rapidas'
    | '/organizacao/setores'
    | '/organizacao/tags'
    | '/organizacao/templates'
    | '/agendamentos'
    | '/agentes'
    | '/cadencias'
    | '/campanhas'
    | '/canais'
    | '/conhecimento'
    | '/grupos'
    | '/integracoes'
    | '/leads'
    | '/organizacao'
    | '/agentes/$agentId/agendamento'
    | '/agentes/$agentId/automacoes'
    | '/agentes/$agentId/configuracoes'
    | '/agentes/$agentId/conhecimento'
    | '/agentes/$agentId/mcp'
    | '/agentes/$agentId/otimizador'
    | '/agentes/$agentId/qualificacao'
    | '/agentes/$agentId/seguranca'
    | '/agentes/$agentId/testes'
    | '/cadencias/$cadenceId/agenda'
    | '/cadencias/$cadenceId/etapas'
    | '/cadencias/$cadenceId/leads'
    | '/cadencias/$cadenceId/relatorio'
    | '/integracoes/google-calendar/callback'
    | '/integracoes/rd-marketing/callback'
    | '/integracoes/rd-marketing/logs'
    | '/integracoes/webhooks/$webhookId'
    | '/integracoes/webhooks/novo'
    | '/cadencias/$cadenceId'
    | '/integracoes/rd-marketing'
    | '/integracoes/webhooks'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/aceitar-convite'
    | '/alterar-senha'
    | '/cadastrar'
    | '/design-system'
    | '/entrar'
    | '/esqueci-senha'
    | '/onboarding'
    | '/redefinir-senha'
    | '/sem-organizacao'
    | '/_app/agendamentos'
    | '/_app/cadencias'
    | '/_app/campanhas'
    | '/_app/config'
    | '/_app/conhecimento'
    | '/_app/convites'
    | '/_app/dashboard'
    | '/_app/inbox'
    | '/_app/integracoes'
    | '/_app/kanban'
    | '/_app/leads'
    | '/_app/nps'
    | '/_app/organizacao'
    | '/_app/perfil'
    | '/_app/relatorio'
    | '/_app/agendamentos/perfis'
    | '/_app/agentes/$agentId'
    | '/_app/cadencias/$cadenceId'
    | '/_app/campanhas/$campaignId'
    | '/_app/conhecimento/$knowledgeBaseId'
    | '/_app/conhecimento/novo'
    | '/_app/integracoes/exact-spotter'
    | '/_app/integracoes/mcp'
    | '/_app/integracoes/rd-marketing'
    | '/_app/integracoes/webhooks'
    | '/_app/integracoes/webhooks-saida'
    | '/_app/leads/$leadId'
    | '/_app/leads/duplicados'
    | '/_app/organizacao/assinatura'
    | '/_app/organizacao/campos'
    | '/_app/organizacao/membros'
    | '/_app/organizacao/mensagens'
    | '/_app/organizacao/midias'
    | '/_app/organizacao/motivos-finalizacao'
    | '/_app/organizacao/nps'
    | '/_app/organizacao/privacidade'
    | '/_app/organizacao/respostas-rapidas'
    | '/_app/organizacao/setores'
    | '/_app/organizacao/tags'
    | '/_app/organizacao/templates'
    | '/_app/agendamentos/'
    | '/_app/agentes/'
    | '/_app/cadencias/'
    | '/_app/campanhas/'
    | '/_app/canais/'
    | '/_app/conhecimento/'
    | '/_app/grupos/'
    | '/_app/integracoes/'
    | '/_app/leads/'
    | '/_app/organizacao/'
    | '/_app/agentes/$agentId/agendamento'
    | '/_app/agentes/$agentId/automacoes'
    | '/_app/agentes/$agentId/configuracoes'
    | '/_app/agentes/$agentId/conhecimento'
    | '/_app/agentes/$agentId/mcp'
    | '/_app/agentes/$agentId/otimizador'
    | '/_app/agentes/$agentId/qualificacao'
    | '/_app/agentes/$agentId/seguranca'
    | '/_app/agentes/$agentId/testes'
    | '/_app/cadencias/$cadenceId/agenda'
    | '/_app/cadencias/$cadenceId/etapas'
    | '/_app/cadencias/$cadenceId/leads'
    | '/_app/cadencias/$cadenceId/relatorio'
    | '/_app/integracoes/google-calendar/callback'
    | '/_app/integracoes/rd-marketing/callback'
    | '/_app/integracoes/rd-marketing/logs'
    | '/_app/integracoes/webhooks/$webhookId'
    | '/_app/integracoes/webhooks/novo'
    | '/_app/cadencias/$cadenceId/'
    | '/_app/integracoes/rd-marketing/'
    | '/_app/integracoes/webhooks/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AceitarConviteRoute: typeof AceitarConviteRoute
  AlterarSenhaRoute: typeof AlterarSenhaRoute
  CadastrarRoute: typeof CadastrarRoute
  DesignSystemRoute: typeof DesignSystemRoute
  EntrarRoute: typeof EntrarRoute
  EsqueciSenhaRoute: typeof EsqueciSenhaRoute
  OnboardingRoute: typeof OnboardingRoute
  RedefinirSenhaRoute: typeof RedefinirSenhaRoute
  SemOrganizacaoRoute: typeof SemOrganizacaoRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sem-organizacao': {
      id: '/sem-organizacao'
      path: '/sem-organizacao'
      fullPath: '/sem-organizacao'
      preLoaderRoute: typeof SemOrganizacaoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/redefinir-senha': {
      id: '/redefinir-senha'
      path: '/redefinir-senha'
      fullPath: '/redefinir-senha'
      preLoaderRoute: typeof RedefinirSenhaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/esqueci-senha': {
      id: '/esqueci-senha'
      path: '/esqueci-senha'
      fullPath: '/esqueci-senha'
      preLoaderRoute: typeof EsqueciSenhaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entrar': {
      id: '/entrar'
      path: '/entrar'
      fullPath: '/entrar'
      preLoaderRoute: typeof EntrarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design-system': {
      id: '/design-system'
      path: '/design-system'
      fullPath: '/design-system'
      preLoaderRoute: typeof DesignSystemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cadastrar': {
      id: '/cadastrar'
      path: '/cadastrar'
      fullPath: '/cadastrar'
      preLoaderRoute: typeof CadastrarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alterar-senha': {
      id: '/alterar-senha'
      path: '/alterar-senha'
      fullPath: '/alterar-senha'
      preLoaderRoute: typeof AlterarSenhaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/aceitar-convite': {
      id: '/aceitar-convite'
      path: '/aceitar-convite'
      fullPath: '/aceitar-convite'
      preLoaderRoute: typeof AceitarConviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/relatorio': {
      id: '/_app/relatorio'
      path: '/relatorio'
      fullPath: '/relatorio'
      preLoaderRoute: typeof AppRelatorioRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/perfil': {
      id: '/_app/perfil'
      path: '/perfil'
      fullPath: '/perfil'
      preLoaderRoute: typeof AppPerfilRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organizacao': {
      id: '/_app/organizacao'
      path: '/organizacao'
      fullPath: '/organizacao'
      preLoaderRoute: typeof AppOrganizacaoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/nps': {
      id: '/_app/nps'
      path: '/nps'
      fullPath: '/nps'
      preLoaderRoute: typeof AppNpsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leads': {
      id: '/_app/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof AppLeadsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/kanban': {
      id: '/_app/kanban'
      path: '/kanban'
      fullPath: '/kanban'
      preLoaderRoute: typeof AppKanbanRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/integracoes': {
      id: '/_app/integracoes'
      path: '/integracoes'
      fullPath: '/integracoes'
      preLoaderRoute: typeof AppIntegracoesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/convites': {
      id: '/_app/convites'
      path: '/convites'
      fullPath: '/convites'
      preLoaderRoute: typeof AppConvitesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/conhecimento': {
      id: '/_app/conhecimento'
      path: '/conhecimento'
      fullPath: '/conhecimento'
      preLoaderRoute: typeof AppConhecimentoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/config': {
      id: '/_app/config'
      path: '/config'
      fullPath: '/config'
      preLoaderRoute: typeof AppConfigRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/campanhas': {
      id: '/_app/campanhas'
      path: '/campanhas'
      fullPath: '/campanhas'
      preLoaderRoute: typeof AppCampanhasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadencias': {
      id: '/_app/cadencias'
      path: '/cadencias'
      fullPath: '/cadencias'
      preLoaderRoute: typeof AppCadenciasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agendamentos': {
      id: '/_app/agendamentos'
      path: '/agendamentos'
      fullPath: '/agendamentos'
      preLoaderRoute: typeof AppAgendamentosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organizacao/': {
      id: '/_app/organizacao/'
      path: '/'
      fullPath: '/organizacao/'
      preLoaderRoute: typeof AppOrganizacaoIndexRouteImport
      parentRoute: typeof AppOrganizacaoRoute
    }
    '/_app/leads/': {
      id: '/_app/leads/'
      path: '/'
      fullPath: '/leads/'
      preLoaderRoute: typeof AppLeadsIndexRouteImport
      parentRoute: typeof AppLeadsRoute
    }
    '/_app/integracoes/': {
      id: '/_app/integracoes/'
      path: '/'
      fullPath: '/integracoes/'
      preLoaderRoute: typeof AppIntegracoesIndexRouteImport
      parentRoute: typeof AppIntegracoesRoute
    }
    '/_app/grupos/': {
      id: '/_app/grupos/'
      path: '/grupos'
      fullPath: '/grupos/'
      preLoaderRoute: typeof AppGruposIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/conhecimento/': {
      id: '/_app/conhecimento/'
      path: '/'
      fullPath: '/conhecimento/'
      preLoaderRoute: typeof AppConhecimentoIndexRouteImport
      parentRoute: typeof AppConhecimentoRoute
    }
    '/_app/canais/': {
      id: '/_app/canais/'
      path: '/canais'
      fullPath: '/canais/'
      preLoaderRoute: typeof AppCanaisIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/campanhas/': {
      id: '/_app/campanhas/'
      path: '/'
      fullPath: '/campanhas/'
      preLoaderRoute: typeof AppCampanhasIndexRouteImport
      parentRoute: typeof AppCampanhasRoute
    }
    '/_app/cadencias/': {
      id: '/_app/cadencias/'
      path: '/'
      fullPath: '/cadencias/'
      preLoaderRoute: typeof AppCadenciasIndexRouteImport
      parentRoute: typeof AppCadenciasRoute
    }
    '/_app/agentes/': {
      id: '/_app/agentes/'
      path: '/agentes'
      fullPath: '/agentes/'
      preLoaderRoute: typeof AppAgentesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agendamentos/': {
      id: '/_app/agendamentos/'
      path: '/'
      fullPath: '/agendamentos/'
      preLoaderRoute: typeof AppAgendamentosIndexRouteImport
      parentRoute: typeof AppAgendamentosRoute
    }
    '/_app/organizacao/templates': {
      id: '/_app/organizacao/templates'
      path: '/templates'
      fullPath: '/organizacao/templates'
      preLoaderRoute: typeof AppOrganizacaoTemplatesRouteImport
      parentRoute: typeof AppOrganizacaoRoute
    }
    '/_app/organizacao/tags': {
      id: '/_app/organizacao/tags'
      path: '/tags'
      fullPath: '/organizacao/tags'
      preLoaderRoute: typeof AppOrganizacaoTagsRouteImport
      parentRoute: typeof AppOrganizacaoRoute
    }
    '/_app/organizacao/setores': {
      id: '/_app/organizacao/setores'
      path: '/setores'
      fullPath: '/organizacao/setores'
      preLoaderRoute: typeof AppOrganizacaoSetoresRouteImport
      parentRoute: typeof AppOrganizacaoRoute
    }
    '/_app/organizacao/respostas-rapidas': {
      id: '/_app/organizacao/respostas-rapidas'
      path: '/respostas-rapidas'
      fullPath: '/organizacao/respostas-rapidas'
      preLoaderRoute: typeof AppOrganizacaoRespostasRapidasRouteImport
      parentRoute: typeof AppOrganizacaoRoute
    }
    '/_app/organizacao/privacidade': {
      id: '/_app/organizacao/privacidade'
      path: '/privacidade'
      fullPath: '/organizacao/privacidade'
      preLoaderRoute: typeof AppOrganizacaoPrivacidadeRouteImport
      parentRoute: typeof AppOrganizacaoRoute
    }
    '/_app/organizacao/nps': {
      id: '/_app/organizacao/nps'
      path: '/nps'
      fullPath: '/organizacao/nps'
      preLoaderRoute: typeof AppOrganizacaoNpsRouteImport
      parentRoute: typeof AppOrganizacaoRoute
    }
    '/_app/organizacao/motivos-finalizacao': {
      id: '/_app/organizacao/motivos-finalizacao'
      path: '/motivos-finalizacao'
      fullPath: '/organizacao/motivos-finalizacao'
      preLoaderRoute: typeof AppOrganizacaoMotivosFinalizacaoRouteImport
      parentRoute: typeof AppOrganizacaoRoute
    }
    '/_app/organizacao/midias': {
      id: '/_app/organizacao/midias'
      path: '/midias'
      fullPath: '/organizacao/midias'
      preLoaderRoute: typeof AppOrganizacaoMidiasRouteImport
      parentRoute: typeof AppOrganizacaoRoute
    }
    '/_app/organizacao/mensagens': {
      id: '/_app/organizacao/mensagens'
      path: '/mensagens'
      fullPath: '/organizacao/mensagens'
      preLoaderRoute: typeof AppOrganizacaoMensagensRouteImport
      parentRoute: typeof AppOrganizacaoRoute
    }
    '/_app/organizacao/membros': {
      id: '/_app/organizacao/membros'
      path: '/membros'
      fullPath: '/organizacao/membros'
      preLoaderRoute: typeof AppOrganizacaoMembrosRouteImport
      parentRoute: typeof AppOrganizacaoRoute
    }
    '/_app/organizacao/campos': {
      id: '/_app/organizacao/campos'
      path: '/campos'
      fullPath: '/organizacao/campos'
      preLoaderRoute: typeof AppOrganizacaoCamposRouteImport
      parentRoute: typeof AppOrganizacaoRoute
    }
    '/_app/organizacao/assinatura': {
      id: '/_app/organizacao/assinatura'
      path: '/assinatura'
      fullPath: '/organizacao/assinatura'
      preLoaderRoute: typeof AppOrganizacaoAssinaturaRouteImport
      parentRoute: typeof AppOrganizacaoRoute
    }
    '/_app/leads/duplicados': {
      id: '/_app/leads/duplicados'
      path: '/duplicados'
      fullPath: '/leads/duplicados'
      preLoaderRoute: typeof AppLeadsDuplicadosRouteImport
      parentRoute: typeof AppLeadsRoute
    }
    '/_app/leads/$leadId': {
      id: '/_app/leads/$leadId'
      path: '/$leadId'
      fullPath: '/leads/$leadId'
      preLoaderRoute: typeof AppLeadsLeadIdRouteImport
      parentRoute: typeof AppLeadsRoute
    }
    '/_app/integracoes/webhooks-saida': {
      id: '/_app/integracoes/webhooks-saida'
      path: '/webhooks-saida'
      fullPath: '/integracoes/webhooks-saida'
      preLoaderRoute: typeof AppIntegracoesWebhooksSaidaRouteImport
      parentRoute: typeof AppIntegracoesRoute
    }
    '/_app/integracoes/webhooks': {
      id: '/_app/integracoes/webhooks'
      path: '/webhooks'
      fullPath: '/integracoes/webhooks'
      preLoaderRoute: typeof AppIntegracoesWebhooksRouteImport
      parentRoute: typeof AppIntegracoesRoute
    }
    '/_app/integracoes/rd-marketing': {
      id: '/_app/integracoes/rd-marketing'
      path: '/rd-marketing'
      fullPath: '/integracoes/rd-marketing'
      preLoaderRoute: typeof AppIntegracoesRdMarketingRouteImport
      parentRoute: typeof AppIntegracoesRoute
    }
    '/_app/integracoes/mcp': {
      id: '/_app/integracoes/mcp'
      path: '/mcp'
      fullPath: '/integracoes/mcp'
      preLoaderRoute: typeof AppIntegracoesMcpRouteImport
      parentRoute: typeof AppIntegracoesRoute
    }
    '/_app/integracoes/exact-spotter': {
      id: '/_app/integracoes/exact-spotter'
      path: '/exact-spotter'
      fullPath: '/integracoes/exact-spotter'
      preLoaderRoute: typeof AppIntegracoesExactSpotterRouteImport
      parentRoute: typeof AppIntegracoesRoute
    }
    '/_app/conhecimento/novo': {
      id: '/_app/conhecimento/novo'
      path: '/novo'
      fullPath: '/conhecimento/novo'
      preLoaderRoute: typeof AppConhecimentoNovoRouteImport
      parentRoute: typeof AppConhecimentoRoute
    }
    '/_app/conhecimento/$knowledgeBaseId': {
      id: '/_app/conhecimento/$knowledgeBaseId'
      path: '/$knowledgeBaseId'
      fullPath: '/conhecimento/$knowledgeBaseId'
      preLoaderRoute: typeof AppConhecimentoKnowledgeBaseIdRouteImport
      parentRoute: typeof AppConhecimentoRoute
    }
    '/_app/campanhas/$campaignId': {
      id: '/_app/campanhas/$campaignId'
      path: '/$campaignId'
      fullPath: '/campanhas/$campaignId'
      preLoaderRoute: typeof AppCampanhasCampaignIdRouteImport
      parentRoute: typeof AppCampanhasRoute
    }
    '/_app/cadencias/$cadenceId': {
      id: '/_app/cadencias/$cadenceId'
      path: '/$cadenceId'
      fullPath: '/cadencias/$cadenceId'
      preLoaderRoute: typeof AppCadenciasCadenceIdRouteImport
      parentRoute: typeof AppCadenciasRoute
    }
    '/_app/agentes/$agentId': {
      id: '/_app/agentes/$agentId'
      path: '/agentes/$agentId'
      fullPath: '/agentes/$agentId'
      preLoaderRoute: typeof AppAgentesAgentIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agendamentos/perfis': {
      id: '/_app/agendamentos/perfis'
      path: '/perfis'
      fullPath: '/agendamentos/perfis'
      preLoaderRoute: typeof AppAgendamentosPerfisRouteImport
      parentRoute: typeof AppAgendamentosRoute
    }
    '/_app/integracoes/webhooks/': {
      id: '/_app/integracoes/webhooks/'
      path: '/'
      fullPath: '/integracoes/webhooks/'
      preLoaderRoute: typeof AppIntegracoesWebhooksIndexRouteImport
      parentRoute: typeof AppIntegracoesWebhooksRoute
    }
    '/_app/integracoes/rd-marketing/': {
      id: '/_app/integracoes/rd-marketing/'
      path: '/'
      fullPath: '/integracoes/rd-marketing/'
      preLoaderRoute: typeof AppIntegracoesRdMarketingIndexRouteImport
      parentRoute: typeof AppIntegracoesRdMarketingRoute
    }
    '/_app/cadencias/$cadenceId/': {
      id: '/_app/cadencias/$cadenceId/'
      path: '/'
      fullPath: '/cadencias/$cadenceId/'
      preLoaderRoute: typeof AppCadenciasCadenceIdIndexRouteImport
      parentRoute: typeof AppCadenciasCadenceIdRoute
    }
    '/_app/integracoes/webhooks/novo': {
      id: '/_app/integracoes/webhooks/novo'
      path: '/novo'
      fullPath: '/integracoes/webhooks/novo'
      preLoaderRoute: typeof AppIntegracoesWebhooksNovoRouteImport
      parentRoute: typeof AppIntegracoesWebhooksRoute
    }
    '/_app/integracoes/webhooks/$webhookId': {
      id: '/_app/integracoes/webhooks/$webhookId'
      path: '/$webhookId'
      fullPath: '/integracoes/webhooks/$webhookId'
      preLoaderRoute: typeof AppIntegracoesWebhooksWebhookIdRouteImport
      parentRoute: typeof AppIntegracoesWebhooksRoute
    }
    '/_app/integracoes/rd-marketing/logs': {
      id: '/_app/integracoes/rd-marketing/logs'
      path: '/logs'
      fullPath: '/integracoes/rd-marketing/logs'
      preLoaderRoute: typeof AppIntegracoesRdMarketingLogsRouteImport
      parentRoute: typeof AppIntegracoesRdMarketingRoute
    }
    '/_app/integracoes/rd-marketing/callback': {
      id: '/_app/integracoes/rd-marketing/callback'
      path: '/callback'
      fullPath: '/integracoes/rd-marketing/callback'
      preLoaderRoute: typeof AppIntegracoesRdMarketingCallbackRouteImport
      parentRoute: typeof AppIntegracoesRdMarketingRoute
    }
    '/_app/integracoes/google-calendar/callback': {
      id: '/_app/integracoes/google-calendar/callback'
      path: '/google-calendar/callback'
      fullPath: '/integracoes/google-calendar/callback'
      preLoaderRoute: typeof AppIntegracoesGoogleCalendarCallbackRouteImport
      parentRoute: typeof AppIntegracoesRoute
    }
    '/_app/cadencias/$cadenceId/relatorio': {
      id: '/_app/cadencias/$cadenceId/relatorio'
      path: '/relatorio'
      fullPath: '/cadencias/$cadenceId/relatorio'
      preLoaderRoute: typeof AppCadenciasCadenceIdRelatorioRouteImport
      parentRoute: typeof AppCadenciasCadenceIdRoute
    }
    '/_app/cadencias/$cadenceId/leads': {
      id: '/_app/cadencias/$cadenceId/leads'
      path: '/leads'
      fullPath: '/cadencias/$cadenceId/leads'
      preLoaderRoute: typeof AppCadenciasCadenceIdLeadsRouteImport
      parentRoute: typeof AppCadenciasCadenceIdRoute
    }
    '/_app/cadencias/$cadenceId/etapas': {
      id: '/_app/cadencias/$cadenceId/etapas'
      path: '/etapas'
      fullPath: '/cadencias/$cadenceId/etapas'
      preLoaderRoute: typeof AppCadenciasCadenceIdEtapasRouteImport
      parentRoute: typeof AppCadenciasCadenceIdRoute
    }
    '/_app/cadencias/$cadenceId/agenda': {
      id: '/_app/cadencias/$cadenceId/agenda'
      path: '/agenda'
      fullPath: '/cadencias/$cadenceId/agenda'
      preLoaderRoute: typeof AppCadenciasCadenceIdAgendaRouteImport
      parentRoute: typeof AppCadenciasCadenceIdRoute
    }
    '/_app/agentes/$agentId/testes': {
      id: '/_app/agentes/$agentId/testes'
      path: '/testes'
      fullPath: '/agentes/$agentId/testes'
      preLoaderRoute: typeof AppAgentesAgentIdTestesRouteImport
      parentRoute: typeof AppAgentesAgentIdRoute
    }
    '/_app/agentes/$agentId/seguranca': {
      id: '/_app/agentes/$agentId/seguranca'
      path: '/seguranca'
      fullPath: '/agentes/$agentId/seguranca'
      preLoaderRoute: typeof AppAgentesAgentIdSegurancaRouteImport
      parentRoute: typeof AppAgentesAgentIdRoute
    }
    '/_app/agentes/$agentId/qualificacao': {
      id: '/_app/agentes/$agentId/qualificacao'
      path: '/qualificacao'
      fullPath: '/agentes/$agentId/qualificacao'
      preLoaderRoute: typeof AppAgentesAgentIdQualificacaoRouteImport
      parentRoute: typeof AppAgentesAgentIdRoute
    }
    '/_app/agentes/$agentId/otimizador': {
      id: '/_app/agentes/$agentId/otimizador'
      path: '/otimizador'
      fullPath: '/agentes/$agentId/otimizador'
      preLoaderRoute: typeof AppAgentesAgentIdOtimizadorRouteImport
      parentRoute: typeof AppAgentesAgentIdRoute
    }
    '/_app/agentes/$agentId/mcp': {
      id: '/_app/agentes/$agentId/mcp'
      path: '/mcp'
      fullPath: '/agentes/$agentId/mcp'
      preLoaderRoute: typeof AppAgentesAgentIdMcpRouteImport
      parentRoute: typeof AppAgentesAgentIdRoute
    }
    '/_app/agentes/$agentId/conhecimento': {
      id: '/_app/agentes/$agentId/conhecimento'
      path: '/conhecimento'
      fullPath: '/agentes/$agentId/conhecimento'
      preLoaderRoute: typeof AppAgentesAgentIdConhecimentoRouteImport
      parentRoute: typeof AppAgentesAgentIdRoute
    }
    '/_app/agentes/$agentId/configuracoes': {
      id: '/_app/agentes/$agentId/configuracoes'
      path: '/configuracoes'
      fullPath: '/agentes/$agentId/configuracoes'
      preLoaderRoute: typeof AppAgentesAgentIdConfiguracoesRouteImport
      parentRoute: typeof AppAgentesAgentIdRoute
    }
    '/_app/agentes/$agentId/automacoes': {
      id: '/_app/agentes/$agentId/automacoes'
      path: '/automacoes'
      fullPath: '/agentes/$agentId/automacoes'
      preLoaderRoute: typeof AppAgentesAgentIdAutomacoesRouteImport
      parentRoute: typeof AppAgentesAgentIdRoute
    }
    '/_app/agentes/$agentId/agendamento': {
      id: '/_app/agentes/$agentId/agendamento'
      path: '/agendamento'
      fullPath: '/agentes/$agentId/agendamento'
      preLoaderRoute: typeof AppAgentesAgentIdAgendamentoRouteImport
      parentRoute: typeof AppAgentesAgentIdRoute
    }
  }
}

interface AppAgendamentosRouteChildren {
  AppAgendamentosPerfisRoute: typeof AppAgendamentosPerfisRoute
  AppAgendamentosIndexRoute: typeof AppAgendamentosIndexRoute
}

const AppAgendamentosRouteChildren: AppAgendamentosRouteChildren = {
  AppAgendamentosPerfisRoute: AppAgendamentosPerfisRoute,
  AppAgendamentosIndexRoute: AppAgendamentosIndexRoute,
}

const AppAgendamentosRouteWithChildren = AppAgendamentosRoute._addFileChildren(
  AppAgendamentosRouteChildren,
)

interface AppCadenciasCadenceIdRouteChildren {
  AppCadenciasCadenceIdAgendaRoute: typeof AppCadenciasCadenceIdAgendaRoute
  AppCadenciasCadenceIdEtapasRoute: typeof AppCadenciasCadenceIdEtapasRoute
  AppCadenciasCadenceIdLeadsRoute: typeof AppCadenciasCadenceIdLeadsRoute
  AppCadenciasCadenceIdRelatorioRoute: typeof AppCadenciasCadenceIdRelatorioRoute
  AppCadenciasCadenceIdIndexRoute: typeof AppCadenciasCadenceIdIndexRoute
}

const AppCadenciasCadenceIdRouteChildren: AppCadenciasCadenceIdRouteChildren = {
  AppCadenciasCadenceIdAgendaRoute: AppCadenciasCadenceIdAgendaRoute,
  AppCadenciasCadenceIdEtapasRoute: AppCadenciasCadenceIdEtapasRoute,
  AppCadenciasCadenceIdLeadsRoute: AppCadenciasCadenceIdLeadsRoute,
  AppCadenciasCadenceIdRelatorioRoute: AppCadenciasCadenceIdRelatorioRoute,
  AppCadenciasCadenceIdIndexRoute: AppCadenciasCadenceIdIndexRoute,
}

const AppCadenciasCadenceIdRouteWithChildren =
  AppCadenciasCadenceIdRoute._addFileChildren(
    AppCadenciasCadenceIdRouteChildren,
  )

interface AppCadenciasRouteChildren {
  AppCadenciasCadenceIdRoute: typeof AppCadenciasCadenceIdRouteWithChildren
  AppCadenciasIndexRoute: typeof AppCadenciasIndexRoute
}

const AppCadenciasRouteChildren: AppCadenciasRouteChildren = {
  AppCadenciasCadenceIdRoute: AppCadenciasCadenceIdRouteWithChildren,
  AppCadenciasIndexRoute: AppCadenciasIndexRoute,
}

const AppCadenciasRouteWithChildren = AppCadenciasRoute._addFileChildren(
  AppCadenciasRouteChildren,
)

interface AppCampanhasRouteChildren {
  AppCampanhasCampaignIdRoute: typeof AppCampanhasCampaignIdRoute
  AppCampanhasIndexRoute: typeof AppCampanhasIndexRoute
}

const AppCampanhasRouteChildren: AppCampanhasRouteChildren = {
  AppCampanhasCampaignIdRoute: AppCampanhasCampaignIdRoute,
  AppCampanhasIndexRoute: AppCampanhasIndexRoute,
}

const AppCampanhasRouteWithChildren = AppCampanhasRoute._addFileChildren(
  AppCampanhasRouteChildren,
)

interface AppConhecimentoRouteChildren {
  AppConhecimentoKnowledgeBaseIdRoute: typeof AppConhecimentoKnowledgeBaseIdRoute
  AppConhecimentoNovoRoute: typeof AppConhecimentoNovoRoute
  AppConhecimentoIndexRoute: typeof AppConhecimentoIndexRoute
}

const AppConhecimentoRouteChildren: AppConhecimentoRouteChildren = {
  AppConhecimentoKnowledgeBaseIdRoute: AppConhecimentoKnowledgeBaseIdRoute,
  AppConhecimentoNovoRoute: AppConhecimentoNovoRoute,
  AppConhecimentoIndexRoute: AppConhecimentoIndexRoute,
}

const AppConhecimentoRouteWithChildren = AppConhecimentoRoute._addFileChildren(
  AppConhecimentoRouteChildren,
)

interface AppIntegracoesRdMarketingRouteChildren {
  AppIntegracoesRdMarketingCallbackRoute: typeof AppIntegracoesRdMarketingCallbackRoute
  AppIntegracoesRdMarketingLogsRoute: typeof AppIntegracoesRdMarketingLogsRoute
  AppIntegracoesRdMarketingIndexRoute: typeof AppIntegracoesRdMarketingIndexRoute
}

const AppIntegracoesRdMarketingRouteChildren: AppIntegracoesRdMarketingRouteChildren =
  {
    AppIntegracoesRdMarketingCallbackRoute:
      AppIntegracoesRdMarketingCallbackRoute,
    AppIntegracoesRdMarketingLogsRoute: AppIntegracoesRdMarketingLogsRoute,
    AppIntegracoesRdMarketingIndexRoute: AppIntegracoesRdMarketingIndexRoute,
  }

const AppIntegracoesRdMarketingRouteWithChildren =
  AppIntegracoesRdMarketingRoute._addFileChildren(
    AppIntegracoesRdMarketingRouteChildren,
  )

interface AppIntegracoesWebhooksRouteChildren {
  AppIntegracoesWebhooksWebhookIdRoute: typeof AppIntegracoesWebhooksWebhookIdRoute
  AppIntegracoesWebhooksNovoRoute: typeof AppIntegracoesWebhooksNovoRoute
  AppIntegracoesWebhooksIndexRoute: typeof AppIntegracoesWebhooksIndexRoute
}

const AppIntegracoesWebhooksRouteChildren: AppIntegracoesWebhooksRouteChildren =
  {
    AppIntegracoesWebhooksWebhookIdRoute: AppIntegracoesWebhooksWebhookIdRoute,
    AppIntegracoesWebhooksNovoRoute: AppIntegracoesWebhooksNovoRoute,
    AppIntegracoesWebhooksIndexRoute: AppIntegracoesWebhooksIndexRoute,
  }

const AppIntegracoesWebhooksRouteWithChildren =
  AppIntegracoesWebhooksRoute._addFileChildren(
    AppIntegracoesWebhooksRouteChildren,
  )

interface AppIntegracoesRouteChildren {
  AppIntegracoesExactSpotterRoute: typeof AppIntegracoesExactSpotterRoute
  AppIntegracoesMcpRoute: typeof AppIntegracoesMcpRoute
  AppIntegracoesRdMarketingRoute: typeof AppIntegracoesRdMarketingRouteWithChildren
  AppIntegracoesWebhooksRoute: typeof AppIntegracoesWebhooksRouteWithChildren
  AppIntegracoesWebhooksSaidaRoute: typeof AppIntegracoesWebhooksSaidaRoute
  AppIntegracoesIndexRoute: typeof AppIntegracoesIndexRoute
  AppIntegracoesGoogleCalendarCallbackRoute: typeof AppIntegracoesGoogleCalendarCallbackRoute
}

const AppIntegracoesRouteChildren: AppIntegracoesRouteChildren = {
  AppIntegracoesExactSpotterRoute: AppIntegracoesExactSpotterRoute,
  AppIntegracoesMcpRoute: AppIntegracoesMcpRoute,
  AppIntegracoesRdMarketingRoute: AppIntegracoesRdMarketingRouteWithChildren,
  AppIntegracoesWebhooksRoute: AppIntegracoesWebhooksRouteWithChildren,
  AppIntegracoesWebhooksSaidaRoute: AppIntegracoesWebhooksSaidaRoute,
  AppIntegracoesIndexRoute: AppIntegracoesIndexRoute,
  AppIntegracoesGoogleCalendarCallbackRoute:
    AppIntegracoesGoogleCalendarCallbackRoute,
}

const AppIntegracoesRouteWithChildren = AppIntegracoesRoute._addFileChildren(
  AppIntegracoesRouteChildren,
)

interface AppLeadsRouteChildren {
  AppLeadsLeadIdRoute: typeof AppLeadsLeadIdRoute
  AppLeadsDuplicadosRoute: typeof AppLeadsDuplicadosRoute
  AppLeadsIndexRoute: typeof AppLeadsIndexRoute
}

const AppLeadsRouteChildren: AppLeadsRouteChildren = {
  AppLeadsLeadIdRoute: AppLeadsLeadIdRoute,
  AppLeadsDuplicadosRoute: AppLeadsDuplicadosRoute,
  AppLeadsIndexRoute: AppLeadsIndexRoute,
}

const AppLeadsRouteWithChildren = AppLeadsRoute._addFileChildren(
  AppLeadsRouteChildren,
)

interface AppOrganizacaoRouteChildren {
  AppOrganizacaoAssinaturaRoute: typeof AppOrganizacaoAssinaturaRoute
  AppOrganizacaoCamposRoute: typeof AppOrganizacaoCamposRoute
  AppOrganizacaoMembrosRoute: typeof AppOrganizacaoMembrosRoute
  AppOrganizacaoMensagensRoute: typeof AppOrganizacaoMensagensRoute
  AppOrganizacaoMidiasRoute: typeof AppOrganizacaoMidiasRoute
  AppOrganizacaoMotivosFinalizacaoRoute: typeof AppOrganizacaoMotivosFinalizacaoRoute
  AppOrganizacaoNpsRoute: typeof AppOrganizacaoNpsRoute
  AppOrganizacaoPrivacidadeRoute: typeof AppOrganizacaoPrivacidadeRoute
  AppOrganizacaoRespostasRapidasRoute: typeof AppOrganizacaoRespostasRapidasRoute
  AppOrganizacaoSetoresRoute: typeof AppOrganizacaoSetoresRoute
  AppOrganizacaoTagsRoute: typeof AppOrganizacaoTagsRoute
  AppOrganizacaoTemplatesRoute: typeof AppOrganizacaoTemplatesRoute
  AppOrganizacaoIndexRoute: typeof AppOrganizacaoIndexRoute
}

const AppOrganizacaoRouteChildren: AppOrganizacaoRouteChildren = {
  AppOrganizacaoAssinaturaRoute: AppOrganizacaoAssinaturaRoute,
  AppOrganizacaoCamposRoute: AppOrganizacaoCamposRoute,
  AppOrganizacaoMembrosRoute: AppOrganizacaoMembrosRoute,
  AppOrganizacaoMensagensRoute: AppOrganizacaoMensagensRoute,
  AppOrganizacaoMidiasRoute: AppOrganizacaoMidiasRoute,
  AppOrganizacaoMotivosFinalizacaoRoute: AppOrganizacaoMotivosFinalizacaoRoute,
  AppOrganizacaoNpsRoute: AppOrganizacaoNpsRoute,
  AppOrganizacaoPrivacidadeRoute: AppOrganizacaoPrivacidadeRoute,
  AppOrganizacaoRespostasRapidasRoute: AppOrganizacaoRespostasRapidasRoute,
  AppOrganizacaoSetoresRoute: AppOrganizacaoSetoresRoute,
  AppOrganizacaoTagsRoute: AppOrganizacaoTagsRoute,
  AppOrganizacaoTemplatesRoute: AppOrganizacaoTemplatesRoute,
  AppOrganizacaoIndexRoute: AppOrganizacaoIndexRoute,
}

const AppOrganizacaoRouteWithChildren = AppOrganizacaoRoute._addFileChildren(
  AppOrganizacaoRouteChildren,
)

interface AppAgentesAgentIdRouteChildren {
  AppAgentesAgentIdAgendamentoRoute: typeof AppAgentesAgentIdAgendamentoRoute
  AppAgentesAgentIdAutomacoesRoute: typeof AppAgentesAgentIdAutomacoesRoute
  AppAgentesAgentIdConfiguracoesRoute: typeof AppAgentesAgentIdConfiguracoesRoute
  AppAgentesAgentIdConhecimentoRoute: typeof AppAgentesAgentIdConhecimentoRoute
  AppAgentesAgentIdMcpRoute: typeof AppAgentesAgentIdMcpRoute
  AppAgentesAgentIdOtimizadorRoute: typeof AppAgentesAgentIdOtimizadorRoute
  AppAgentesAgentIdQualificacaoRoute: typeof AppAgentesAgentIdQualificacaoRoute
  AppAgentesAgentIdSegurancaRoute: typeof AppAgentesAgentIdSegurancaRoute
  AppAgentesAgentIdTestesRoute: typeof AppAgentesAgentIdTestesRoute
}

const AppAgentesAgentIdRouteChildren: AppAgentesAgentIdRouteChildren = {
  AppAgentesAgentIdAgendamentoRoute: AppAgentesAgentIdAgendamentoRoute,
  AppAgentesAgentIdAutomacoesRoute: AppAgentesAgentIdAutomacoesRoute,
  AppAgentesAgentIdConfiguracoesRoute: AppAgentesAgentIdConfiguracoesRoute,
  AppAgentesAgentIdConhecimentoRoute: AppAgentesAgentIdConhecimentoRoute,
  AppAgentesAgentIdMcpRoute: AppAgentesAgentIdMcpRoute,
  AppAgentesAgentIdOtimizadorRoute: AppAgentesAgentIdOtimizadorRoute,
  AppAgentesAgentIdQualificacaoRoute: AppAgentesAgentIdQualificacaoRoute,
  AppAgentesAgentIdSegurancaRoute: AppAgentesAgentIdSegurancaRoute,
  AppAgentesAgentIdTestesRoute: AppAgentesAgentIdTestesRoute,
}

const AppAgentesAgentIdRouteWithChildren =
  AppAgentesAgentIdRoute._addFileChildren(AppAgentesAgentIdRouteChildren)

interface AppRouteChildren {
  AppAgendamentosRoute: typeof AppAgendamentosRouteWithChildren
  AppCadenciasRoute: typeof AppCadenciasRouteWithChildren
  AppCampanhasRoute: typeof AppCampanhasRouteWithChildren
  AppConfigRoute: typeof AppConfigRoute
  AppConhecimentoRoute: typeof AppConhecimentoRouteWithChildren
  AppConvitesRoute: typeof AppConvitesRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppInboxRoute: typeof AppInboxRoute
  AppIntegracoesRoute: typeof AppIntegracoesRouteWithChildren
  AppKanbanRoute: typeof AppKanbanRoute
  AppLeadsRoute: typeof AppLeadsRouteWithChildren
  AppNpsRoute: typeof AppNpsRoute
  AppOrganizacaoRoute: typeof AppOrganizacaoRouteWithChildren
  AppPerfilRoute: typeof AppPerfilRoute
  AppRelatorioRoute: typeof AppRelatorioRoute
  AppAgentesAgentIdRoute: typeof AppAgentesAgentIdRouteWithChildren
  AppAgentesIndexRoute: typeof AppAgentesIndexRoute
  AppCanaisIndexRoute: typeof AppCanaisIndexRoute
  AppGruposIndexRoute: typeof AppGruposIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAgendamentosRoute: AppAgendamentosRouteWithChildren,
  AppCadenciasRoute: AppCadenciasRouteWithChildren,
  AppCampanhasRoute: AppCampanhasRouteWithChildren,
  AppConfigRoute: AppConfigRoute,
  AppConhecimentoRoute: AppConhecimentoRouteWithChildren,
  AppConvitesRoute: AppConvitesRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppInboxRoute: AppInboxRoute,
  AppIntegracoesRoute: AppIntegracoesRouteWithChildren,
  AppKanbanRoute: AppKanbanRoute,
  AppLeadsRoute: AppLeadsRouteWithChildren,
  AppNpsRoute: AppNpsRoute,
  AppOrganizacaoRoute: AppOrganizacaoRouteWithChildren,
  AppPerfilRoute: AppPerfilRoute,
  AppRelatorioRoute: AppRelatorioRoute,
  AppAgentesAgentIdRoute: AppAgentesAgentIdRouteWithChildren,
  AppAgentesIndexRoute: AppAgentesIndexRoute,
  AppCanaisIndexRoute: AppCanaisIndexRoute,
  AppGruposIndexRoute: AppGruposIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AceitarConviteRoute: AceitarConviteRoute,
  AlterarSenhaRoute: AlterarSenhaRoute,
  CadastrarRoute: CadastrarRoute,
  DesignSystemRoute: DesignSystemRoute,
  EntrarRoute: EntrarRoute,
  EsqueciSenhaRoute: EsqueciSenhaRoute,
  OnboardingRoute: OnboardingRoute,
  RedefinirSenhaRoute: RedefinirSenhaRoute,
  SemOrganizacaoRoute: SemOrganizacaoRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
